export function slugify(text) {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g,'')
    .replace(/ +/g,'-')
    ;
}

export function validate(input, type) {
  let patterns = {
    'string': /^[a-zA-Z0-9-_ \\,\\'\\"\\:\\.\\!\\?\\$\\%\\(\\)\\@]+$/,
    'email': /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,12}$/i,
    'integer': /^[0-9]+$/,
  };

  return patterns[type].test(input);
}



// WEBPACK FOOTER //
// ./app/javascript/utils/helpers.js